import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import SaveButton from "../../../components/Buttons/SaveButton";
import DateControl from "../../../components/Fields/DateControl";
import TextboxControl from "../../../components/Fields/TextboxControl";
import { FormConfig } from "../../../components/Fields/Types";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import Translate from "../../../components/Translate";
import { useNotifications } from "../../../contexts/notificationContext";
import ProjectReferenceModel from "../../../models/ProjectReferenceModel";
import DataService from "../../../services/data.service";
import { ProjectPopupProps } from "../../../types/PopupProps";
import { Result } from "../../../types/Result";

const ChangeReferenceCodesPopup: React.FC<ProjectPopupProps> = ({ show, onHide, projectId }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<ProjectReferenceModel[]>([]);

    useEffect(() => {
        getFormData();
    }, [projectId]);

    function getFormData() {
        DataService.get<ProjectReferenceModel[]>('api/v1/ProjectReferences/ByProject/' + projectId)
            .then(response => { setFormData(response) })
    }

    function submit() {
        if (formData) {
            DataService
                .updateTableData(`api/v1/ProjectReferences/UpdateCollection`, formData)
                .then(response => {
                    let isSuccesful = true;
                    response.forEach(x => {
                        handleResult(x);
                        if (!x.isSuccesful)
                            isSuccesful = false
                    });
                    if (isSuccesful === true) {
                        getFormData();
                        if (onHide) {
                            onHide();
                        }
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [],
        handleSubmit: submit,
        showErrors: 'always',
    };

    if (formData) {
        formData.forEach((projectReference, index) => {
            formConfig.fields.push({ name: `${index}.referenceCode`, label: projectReference.externalSystemName, validationRules: [{ type: 'isMaxLength', maxLength: 50 }] });
            formConfig.fields.push({ name: `${index}.readyForExportOn`, label: 'Ready for export on' });
            formConfig.fields.push({ name: `${index}.exportedOn`, label: 'Exported on' });
        })
    }

    const { getControlProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Change reference codes'} >
            <Popup.Body>
                {formData && formData.length > 0 && (
                    <table>
                        <tr>
                            <th className='col-md-2'></th>
                            <th className='col-md-6'><Translate>Reference code</Translate></th>
                            <th className='col-md-2'><Translate>Ready for export</Translate></th>
                            <th className='col-md-2'><Translate>Exported</Translate></th>
                        </tr>
                        {formData.map((reference, index) => {
                            return (
                                <tr>
                                    <td><Form.Label>{reference.externalSystemName}</Form.Label></td>
                                    <td><TextboxControl {...getControlProps(`${index}.referenceCode`)} key={index} /></td>
                                    <td><DateControl {...getControlProps(`${index}.readyForExportOn`)} disabled key={index} /></td>
                                    <td><DateControl {...getControlProps(`${index}.exportedOn`)} disabled key={index} /></td>
                                </tr>
                            )
                        })
                        }
                    </table>
                )}
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} />
            </Popup.Footer>
        </Popup>
    );
}
export default ChangeReferenceCodesPopup;